/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
export class VerticalNavIconService {
private _icons: number = 0;
/**
 * @return {?}
 */
get hasIcons(): boolean {
        return this._icons > 0;
    }
/**
 * @return {?}
 */
registerIcon(): void {
        this._icons++;
    }
/**
 * @return {?}
 */
unregisterIcon(): void {
        this._icons--;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function VerticalNavIconService_tsickle_Closure_declarations() {
/** @type {?} */
VerticalNavIconService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VerticalNavIconService.ctorParameters;
/** @type {?} */
VerticalNavIconService.prototype._icons;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
